export default {
    name: 'pdpError',
    //used error prop to conditionally display error message on template. 
    //TODO: we can use the grey boxes w/o msg as a loading template by setting error prop to false
    props: ['error'],
    data(){
        return {
            
        }
    }
} 